export function isNotFalsy<T>(value: T | undefined): value is T {
	return !!(value);
}
